'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ja;

var _TitleTypes = require('../constants/TitleTypes');

var _TitleTypes2 = _interopRequireDefault(_TitleTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  ja: (_ja = {}, _defineProperty(_ja, _TitleTypes2.default.COMPANY, function (name) {
    return name + ' \u5FA1\u4E2D';
  }), _defineProperty(_ja, _TitleTypes2.default.CUSTOMER, function (name) {
    return name + ' \u69D8';
  }), _ja)
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.327/js/utils/TitleFormatters.js
// module id = 846
// module chunks = 2 3